import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavAcademyFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0,-960) scale(40)",
		children: /* @__PURE__ */ _jsx("path", { d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" })
	})
});
export default SvgNavAcademyFill;
